import {Emitter} from "@sentrei/common/models/Snackbar";

export default interface GlobalState {
  snackbar: Emitter;
}
